import { web3 } from "@project-serum/anchor";

export const CREATOR_ADDRESS = process.env.CREATOR_ADDRESS as string
export const TREASURY_MINT = process.env.TREASURY_MINT as string
export const CANDY_SHOP_PROGRAM_ID = process.env.CANDY_SHOP_PROGRAM_ID as string
export const network = (process.env.CHAIN_ENV || 'devnet') as web3.Cluster
export const mainnetConnectionUrl = process.env.MAINNET_NODE as string
